import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { unitTransform, unitLabel } from '@services/helper.service';
import { defaultUnits } from '@config';
import Input from '@components/Input';

export default class StairsDimensions extends Component {

  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    options: PropTypes.shape()
  };

  static defaultProps = {
    options: {}
  };

  render() {
    return (
      <div className="calculation">
        <section className="list-type">
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_STEP_HEIGHT.Content}>
          <Input
            id="hst"
            prefix="Hst:"
            postfix={unitLabel(this.props.distanceUnit)}
            type="number"
            minValue={1}
            value={unitTransform(+this.props.options.ground.stairs.height).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
            onUpdate={this.setHst}
          />
        </Tooltip>

        <Tooltip content={APP_TOOLTIPS.TOOLTIP_STEP_DEPTH.Content}>
          <Input
            id="lst"
            prefix="Lst:"
            postfix={unitLabel(this.props.distanceUnit)}
            type="number"
            minValue={1}
            value={unitTransform(+this.props.options.ground.stairs.width).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
            onUpdate={this.setLst}
          />
        </Tooltip>

        <Tooltip content={APP_TOOLTIPS.TOOLTIP_STEP_STRINGER.Content}>
          <Input
            id="tst"
            prefix="Tst:"
            postfix={unitLabel(this.props.distanceUnit)}
            type="number"
            minValue={1}
            value={unitTransform(+this.props.options.ground.stairs.tst).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
            onUpdate={this.setTst}
          />
        </Tooltip>
        </section>
      </div>
    );
  }

  setHst = (value) => {
    this.onUpdate({
      stairs: {
        height: unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    });
  };

  setLst = (value) => {
    this.onUpdate({
      stairs: {
        width: unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    });
  };

  setTst = (value) => {
    this.onUpdate({
      stairs: {
        tst: unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    });
  };

  onUpdate(options) {
    this.props.onUpdate(options);
  }

}




// WEBPACK FOOTER //
// ./src/views/Dimension/components/StairsDimensions/index.js